import { regex } from './regex';

export const isEmail = (message = 'Invalid email address.') => regex('email', message);
